<template>
    <div class="docs">

        <b-container class="mt-4">
            <b-row>
                <b-col md="4">
                    <h3>Create New Document</h3>

                    <div v-for="tool in tools">
                        <button class="btn btn-success create-doc-button col-12 my-2"
                                @click="createNewDoc(tool)">
                            {{ tool.options.label }}
                        </button>
                    </div>

                    <hr class="my-4"/>

                    <h3 class="mt-2">Academic Assessment Generators</h3>

                    <router-link class="btn btn-warning create-doc-button col-12 my-2"
                            to="/legacy/letterNamings">
                        Letter Name Fluency Generator
                    </router-link>
                    <router-link class="btn btn-warning create-doc-button col-12 my-2"
                            to="/legacy/mazes">
                        Maze Passage Generator
                    </router-link>
                    <router-link class="btn btn-warning create-doc-button col-12 my-2"
                            to="/legacy/oralReadings">
                        Oral Reading Fluency Generator
                    </router-link>
                    <router-link class="btn btn-warning create-doc-button col-12 my-2"
                            to="/legacy/writtenExpressions">
                        Written Expression Probe Generator
                    </router-link>
                </b-col>
                <b-col md="8">

                    <h2>My Documents</h2>
                    <div class="mass-doc-actions">
                        <input type="checkbox"
                               @click="selectAllDocs()"
                               v-model="allSelected">
                        Select All Documents
                        <b-btn variant="danger" class="my-3 ml-4" :disabled="!selectedDocs.length" @click="deleteSelectedDocs()">
                            Delete Selected Documents
                        </b-btn>
                    </div>
                    <b-list-group>
                        <b-list-group-item
                            class="doc-item"
                            v-for="(doc,key) in docs">
                            <input type="checkbox"
                                   class="float-left mr-2 mt-1"
                                   :id="`select_doc_${key}`"
                                   :value="key"
                                   @change="updateAllSelected()"
                                   v-model="selectedDocs">
                            <div v-b-toggle="`doc_${key}`">
                                <open-icon name="ellipses" class="float-right"></open-icon>
                                <h5>{{ doc.title }}</h5>
                                <small class="text-muted float-left">
                                    {{ docTool(doc) }}
                                </small>
                                <small class="text-muted float-right">
                                    {{ doc.updated | moment("MMM D, YYYY") }}
                                </small>
                                <div class="clearfix"></div>

                                <b-collapse :id="`doc_${key}`" class="mt-3 text-right">
                                    <b-btn variant="primary" class="mr-3"
                                           :to="`/doc/id/${key}`">
                                        Edit
                                    </b-btn>
                                    <b-btn variant="warning" class="mr-3"
                                           @click="cloneDoc(doc)">
                                        Clone
                                    </b-btn>
                                    <b-btn variant="danger"
                                           @click="deleteDoc(key)">
                                        Delete
                                    </b-btn>
                                </b-collapse>
                            </div>
                        </b-list-group-item>
                    </b-list-group>

                </b-col>
            </b-row>
        </b-container>

    </div>

</template>

<script>
    import Vue from 'vue'

    export default Vue.extend({
        name: 'docs',
        data() {
            return {
                selectedDocs: [],
                allSelected: false,
            }
        },
        computed: {
            tools() {
                return this.$api.TOOLS
            },
            docs() {
                return this.$store.state.docs
            },
            allDocKeys() {
                let allDocs = []
                _.each(this.docs, (doc, key) => {
                    allDocs.push(key)
                })
                return allDocs
            }
        },
        methods: {
            isNewDocument(doc) {
                return doc.updated - doc.created < 100
            },
            createNewDoc(tool) {
                this.$api.createNewDoc(tool)
                    .then((d) => {
                        console.log('saved new doc', d)
                        this.$store.dispatch('loadDocs')
                        this.$router.replace(`/doc/id/${d.key}`)
                    })
            },
            cloneDoc(doc) {
                this.$api.cloneDoc(doc)
            },
            deleteDoc(key) {
                this.$api.deleteDoc(key)
                this.selectedDocs = _.without(this.selectedDocs, key)
            },
            docTool(doc) {
                const tool = this.tools[doc.tool]
                return tool ? tool.options.label : '';
            },
            deleteSelectedDocs() {
                if (confirm('Permanently delete all selected documents? This action cannot be undone.')) {
                    _.each(this.selectedDocs, (key) => {
                        console.log(key)
                        this.$api.deleteDocWithoutConfirm(key)
                    })
                    this.selectedDocs = []
                }
            },
            selectAllDocs() {
                if (!this.allSelected) {
                    this.allSelected = true
                    _.each(this.docs, (doc, key) => {
                        if (!this.selectedDocs.includes(key)) {
                            this.selectedDocs.push(key)
                        }
                    })
                }
                else {
                    this.allSelected = false
                    this.selectedDocs = []
                }
            },
            updateAllSelected() {
                if (this.selectedDocs.length === this.docs.length) {
                    this.allSelected = true
                }
                else {
                    this.allSelected = false
                }
            }
        },
        mounted() {
            this.$store.dispatch('loadDocs')
        },
    })
</script>

<style lang="scss">
.doc-item:hover {
    background-color: #f3f3f3;
}

</style>